import { render } from "./NuevoTurno.vue?vue&type=template&id=5835b0ee&scoped=true&ts=true"
import script from "./NuevoTurno.vue?vue&type=script&lang=ts"
export * from "./NuevoTurno.vue?vue&type=script&lang=ts"

import "./NuevoTurno.vue?vue&type=style&index=0&id=5835b0ee&lang=scss"
import "./NuevoTurno.vue?vue&type=style&index=1&id=5835b0ee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5835b0ee"]])

export default __exports__